var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"central-div"},[_c('AuthView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }